import React from 'react';

import styled from 'styled-components';

import {LazyTooltip} from 'app/components/general/LazyTooltip';
import {PopupEditableField} from 'app/general/widgets/PopupEditableField';
import {useAccountSettingsState} from 'app/settings/api';
import {UpdateMaxUsersLimitModal} from 'app/stripebilling/components/UpdateMaxUsersLimitModal';
import {gt, ngt} from 'app/utils/i18n';

const MaxUsersBadge = styled.span`
  font-size: 120%;
`;

export function MaxMembersLimitRow() {
  const {
    is_no_active_users,
    is_paying,
    max_users_limit: maxUsersLimit,
    billable_user_count: billableUserCount,
    account_id: accountId,
  } = useAccountSettingsState().data!;

  if (!is_no_active_users) {
    return null;
  }

  if (!is_paying) {
    return null;
  }

  return (
    <PopupEditableField
      id="id_max_members_limit"
      label={<span className="section-name">{gt('Members limit')}</span>}
      buttonLabel={gt('Update Limit')}
      helpText={gt(
        'This is the maximum number of members that can be added to your' +
          ' account. You can increase this limit if you want to allow adding more members.'
      )}
      value={
        <LazyTooltip
          tooltip={ngt(
            'There is currently %s member on your account',
            'There are currently %s members on your account',
            billableUserCount
          )}
        >
          <span className="small text-uppercase text-muted">
            {gt(
              'max %s members ',
              <MaxUsersBadge className="text-reset badge badge-light">
                {maxUsersLimit}
              </MaxUsersBadge>
            )}
          </span>
        </LazyTooltip>
      }
    >
      {({isModalOpen, setIsModalOpen}) => (
        <UpdateMaxUsersLimitModal
          accountId={accountId}
          show={isModalOpen}
          currentLimit={maxUsersLimit}
          onClose={() => setIsModalOpen(false)}
        />
      )}
    </PopupEditableField>
  );
}
